<template>
  <div id="admin-sessions">
    <a-row class="margin-top">
      <a-col :md="{ span: 20, offset: 2 }">
        <a-breadcrumb>
          <a-breadcrumb-item>
            <router-link :to="{ name: 'AdminDashboard' }">
              {{ ProjectName }}
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>Favorite message</a-breadcrumb-item>
        </a-breadcrumb>
      </a-col>
    </a-row>
    <a-row class="margin-top">
      <a-col :md="{ span: 10, offset: 2 }">
        <h1>Favorite message</h1>
      </a-col>
      <a-col :md="{ span: 10, offset: 0 }" class="on-right">
        <a-button
          type="danger"
          icon="delete"
          class="icon"
          :disabled="selectedMessage === ''"
          @click="clearScreen"
        >
          Clear screen
        </a-button>
        <a-button
          type="primary"
          icon="play-circle"
          class="icon"
          @click="goToManageChatScreen"
        >
          Back to manage chat screen
        </a-button>
      </a-col>
    </a-row>
    <a-row>
      <a-col :md="{ span: 20, offset: 2 }">
        <a-table row-key=".key" :columns="columns" :data-source="messageFormat">
          <span slot="action" slot-scope="text, record">
            <a-tooltip placement="right">
              <template slot="title">
                <span>Unfavorite</span>
              </template>
              <a-button
                type="primary"
                icon="caret-right"
                class="icon preview"
                :disabled="selectedMessage === record['.key']"
                @click="sendToScreen(record)"
              />
              <a-button
                v-if="record['star'] == true"
                type="primary"
                icon="star"
                class="icon"
                @click="starMessage(record['.key'], false)"
              />
              <a-button
                v-else
                type=""
                icon="star"
                class="icon"
                @click="starMessage(record['.key'], true)"
              />
            </a-tooltip>
          </span>
        </a-table>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(relativeTime)
dayjs.extend(isBetween)
dayjs.locale('th')

export default {
  name: 'AdminManageChat',
  data() {
    return {
      selectedMessage: '',
      messages: [],
      player: null,
      rocketchatServer: null,
      ProjectName: null,
      editSessionId: null,
      createSessionModalVisible: false,
      editSessionModalVisible: false,
      videoPlayersVisible: false,
      now: dayjs(),
      project: {},
      sessions: [],
      columns: [
        {
          title: 'Name',
          dataIndex: 'author',
          width: '15%',
        },
        {
          title: 'Message',
          dataIndex: 'message',
          scopedSlots: { customRender: 'message' },
        },
        {
          title: 'time',
          dataIndex: 'datetime',
          width: '15%',
          scopedSlots: { customRender: 'datetime' },
        },
        {
          title: 'Actions',
          dataIndex: 'action',
          width: '15%',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  computed: {
    messageFormat() {
      return this.messages.map((item) => {
        item.datetime = dayjs(item.timestamp.toDate()).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        return item
      })
    },
  },
  async created() {
    const messageRef = this.$rdb.ref(
      'message/rooms/' + this.$route.params.sessionId
    )
    messageRef.on('value', (snapshot) => {
      if (snapshot.val()) {
        const message = snapshot.val()
        this.selectedMessage = message.id
      }
    })
    await this.$binding(
      'messages',
      this.$db
        .collection(`sessions/${this.$route.params.sessionId}/messages`)
        .where('star', '==', true)
        .where('deleted_at', '==', null)
        .orderBy('timestamp', 'desc')
    )
  },
  async mounted() {
    // try {
    //   await this.$binding('isAdmin', this.$db.collection('admin'))
    // } catch (error) {
    //   this.$router.push({ name: 'AdminLogin' })
    // }

    // this.$auth.onAuthStateChanged(user => {
    //   if (!user) {
    //     this.$router.push({ name: 'AdminLogin' })
    //   }
    // })
    // this.ProjectName = this.project[0].name

    const currentUser = this.$auth.currentUser
    if (!currentUser) {
      this.$router.push({ name: 'AdminLogin' })
    } else {
      if (
        currentUser.uid !== '2P9oTQysOWYZdEVzp4RflvoJeb03' ||
        currentUser.uid !== 'YMXe4xH8WWh4XzimqeYIkBQLvHJ2' ||
        currentUser.uid !== 'xnpI35IGAEW7WMXxnKPAv4eHdIz1' ||
        currentUser.uid !== 'HbS3mIW5FRVRrilqNmjQg3twSsf1' ||
        currentUser.uid !== 'LelHHTX5sohRKmw2xIgu5XtWjth2'
      ) {
        const userData = JSON.parse(
          localStorage.getItem(
            `auth:live-tube-portal:${this.$route.params.projectSlug}`
          )
        )
        if (userData) {
          if (
            userData.username !== 'admin' &&
            this.$route.params.projectSlug !== userData.project_slug
          ) {
            this.$router.push({
              name: 'Login',
              params: {
                projectSlug: this.$route.params.projectSlug,
              },
            })
          }
        }
      }
    }
  },
  methods: {
    goToManageChatScreen() {
      this.$router.push({
        name: 'AdminChatManagement',
        params: {
          sessionId: this.$route.params.sessionId,
        },
      })
    },
    clearScreen() {
      this.selectedMessage = ''
      this.$rdb
        .ref('message/rooms/' + this.$route.params.sessionId)
        .set({ id: '', name: '', message: '' })
    },
    deleteMessage(messageId) {
      const docRef = this.$db
        .collection(`sessions/${this.$route.params.sessionId}/messages`)
        .doc(messageId)

      docRef
        .update({
          deleted_at: this.$firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(() => {
          console.log('Document successfully updated!')
        })
    },
    starMessage(messageId, setStar) {
      const docRef = this.$db
        .collection(`sessions/${this.$route.params.sessionId}/messages`)
        .doc(messageId)
      docRef
        .update({
          star: setStar,
        })
        .then(() => {
          console.log('Document successfully updated!')
        })
    },
    sendToScreen(message) {
      this.selectedMessage = message['.key']
      this.$rdb.ref('message/rooms/' + this.$route.params.sessionId).set({
        id: message['.key'],
        name: message.author,
        message: message.message,
      })
    },
    openEditSessionModal(id) {
      this.editSessionId = id
      this.editSessionModalVisible = true
    },
    deleteSession(id) {
      this.$db.collection('sessions').doc(id).delete()
    },
    openCreateSessionModal() {
      this.createSessionModalVisible = true
    },
    relativeTime(time) {
      return dayjs().to(time)
    },
    closeModal() {
      this.createSessionModalVisible = false
      this.editSessionModalVisible = false
    },
    sessionStatus(startTime, endTime) {
      if (typeof startTime !== 'string' && typeof endTime !== 'string') {
        startTime = dayjs(startTime.toDate())
        endTime = dayjs(endTime.toDate())

        if (this.now.isBefore(startTime)) {
          return 1
        }

        if (this.now.isBetween(startTime, endTime)) {
          return 0
        }

        if (this.now.isAfter(endTime)) {
          return 2
        }
      }
    },
  },
}
</script>

<style lang="scss">
iframe {
  border: 0;
}
#video {
  text-align: center;
}
.on-right {
  text-align: right;
}
.margin-top {
  margin-top: 16px;
}
.icon {
  margin-right: 3px;
  &.preview {
    width: 45px;
  }
}
</style>
